<template>
  <div>
    <q-select
      hide-bottom-space
      options-dense
      dense
      emit-value
      map-options
      outlined
      class="cursor-pointer"
      :value="categoryTempNames"
      :label="$ts('campaign.fields.byCategories')"
    />
    <q-menu v-if="!isReadOnly" ref="catPopover" fit :offset="[0, 0]">
      <div class="category-popover">
        <ul>
          <li v-for="level1 in categories">
            <span
              :class="{ active: isCategorySelected(level1.id) }"
              class="cursor-pointer"
              @click="selectCategory(level1.id, level1.name)"
            >
              <q-icon name="chevron_right" />
              <q-icon v-if="isCategorySelected(level1.id)" name="highlight_off" />
              {{ level1.name }}
            </span>
            <ul>
              <li v-for="level2 in level1.children">
                <span
                  :class="{ active: isCategorySelected(level2.id) }"
                  class="cursor-pointer"
                  @click="selectCategory(level2.id, level2.name)"
                >
                  <q-icon v-if="isCategorySelected(level2.id)" name="highlight_off" />
                  {{ level2.name }}
                </span>
                <ul>
                  <li v-for="level3 in level2.children">
                    <span
                      :class="{ active: isCategorySelected(level3.id) }"
                      class="cursor-pointer"
                      @click="selectCategory(level3.id, level3.name)"
                    >
                      <q-icon v-if="isCategorySelected(level3.id)" name="highlight_off" />
                      {{ level3.name }}
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </q-menu>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CategoryField',
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    value: {},
  },
  watch: {
    selectedCategories: {
      handler() {
        this.getCategoriesNames()
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      categoryData: state => state.productsCMP.productCategories.list.data,
    }),
    selectedCategories: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  data() {
    return {
      categories: [],
      categoryTempNames: [],
    }
  },
  async mounted() {
    await this.getCategories()
    this.getCategoriesNames()
  },
  methods: {
    ...mapActions(['getProductCategoriesAction']),
    async getCategories() {
      if (!this.categories.length) {
        let query = {
          for_sales: true,
          active: true,
          limit: 0,
          offset: 0,
        }
        await this.getProductCategoriesAction(query)
        this.categories = await this.$helpers.unflattenCatogories(this.categoryData)
      }
    },
    isCategorySelected(id) {
      return this.selectedCategories.findIndex(x => x.id === id) !== -1
    },
    selectCategory(id, name) {
      let catIndex = this.selectedCategories.findIndex(x => x.id === id)
      if (catIndex !== -1) {
        this.selectedCategories.splice(catIndex, 1)
      } else {
        this.selectedCategories.push({ name: name, id: id })
      }
    },
    getCategoriesNames() {
      if (typeof this.categoryData !== 'undefined') {
        this.categoryTempNames = []
        this.selectedCategories.forEach(element => {
          let cat = this.categoryData.find(x => x.id === element.id)
          this.categoryTempNames.push(cat.name)
        })
      }
      return this.categoryTempNames
    },
  },
}
</script>
<style lang="stylus">
.options-holder
  border dotted 1px lightgray

.category-popover > ul, .category-popover > ul > li > ul, .category-popover > ul > li > ul > li > ul
  list-style none

.category-popover > ul > li
  padding 6px
  margin-left -30px

.category-popover .active
  color #00c853

.category-popover span:hover
  color: #afafaf
</style>
